<template>
    <purchase_order_list v-if="userInfo.operation_mode == 3" :tab="tab"></purchase_order_list>
    <order_list v-else :tab="tab"></order_list>
</template>

<script>
import order_list from './order_list.vue'
import purchase_order_list from './purchase_order_list.vue'
import {mapState} from "vuex";

export default {
    props: {
        tab: String
    },

    computed: {
        ...mapState(['userInfo', 'systemConfig']),
    },

    components: {
        order_list,purchase_order_list
    }
}
</script>